// Generated by purs version 0.13.0
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var Drown = (function () {
    function Drown() {

    };
    Drown.value = new Drown();
    return Drown;
})();
var Burned = (function () {
    function Burned() {

    };
    Burned.value = new Burned();
    return Burned;
})();
var Eaten = (function () {
    function Eaten() {

    };
    Eaten.value = new Eaten();
    return Eaten;
})();
var Timed = (function () {
    function Timed() {

    };
    Timed.value = new Timed();
    return Timed;
})();
var BlownUp = (function () {
    function BlownUp() {

    };
    BlownUp.value = new BlownUp();
    return BlownUp;
})();
var showDieReason = new Data_Show.Show(function (v) {
    if (v instanceof Drown) {
        return "Drown";
    };
    if (v instanceof Burned) {
        return "Burned";
    };
    if (v instanceof Eaten) {
        return "Eaten";
    };
    if (v instanceof Timed) {
        return "Timed";
    };
    if (v instanceof BlownUp) {
        return "BlownUp";
    };
    throw new Error("Failed pattern match at Chip.Model.DieReason (line 17, column 10 - line 22, column 25): " + [ v.constructor.name ]);
});
var eqDieReason = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Drown && y instanceof Drown) {
            return true;
        };
        if (x instanceof Burned && y instanceof Burned) {
            return true;
        };
        if (x instanceof Eaten && y instanceof Eaten) {
            return true;
        };
        if (x instanceof Timed && y instanceof Timed) {
            return true;
        };
        if (x instanceof BlownUp && y instanceof BlownUp) {
            return true;
        };
        return false;
    };
});
module.exports = {
    Drown: Drown,
    Burned: Burned,
    Eaten: Eaten,
    Timed: Timed,
    BlownUp: BlownUp,
    eqDieReason: eqDieReason,
    showDieReason: showDieReason
};
